export const SITE_TITLE = "Another HN Reader";
export const PAGE_SIZE = 20;
export const MAX_STORIES = 500;
export const SCROLL_OFFSET = 200;
export const MESSAGE_LOADING = "Loading...";
export const MESSAGE_NO_STORIES =
  "No stories returned. Try refreshing the feed or checking your connection.";
export const MESSAGE_END_OF_STORIES =
  "Well done! You've reached the end of the list! Reload to see more stories.";
export const COMMENT_SINGLE = "comment";
export const COMMENT_MULTIPLE = "comments";
export const SCORE_SINGLE = "point";
export const SCORE_MULTIPLE = "points";
export const BUTTON_REFRESH_TEXT = "Refresh";
